export const overwriteRTEDefaultInternalEmbedConfig = (defaultConfig) => ({
  ...defaultConfig,
  metaBlock: [
    { key: "country", valuePath: "tags.countries.data.0.display" },
    { key: "country", valuePath: "tags.countries.data.1.display" },
    { key: "country", valuePath: "tags.countries.data.2.display" },
  ],
});
